<template>
  <div>
    <span style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px" class="has-text-grey">
      {{ setting.label || name }}
      <Tooltip :label="setting.label || name" :content="setting.detail" />
    </span>

    <el-time-select
      v-model="value[name]"
      placeholder="Select time"
      :picker-options="{ start: '00:00', step: '00:15', end: '23:45' }"
    />
  </div>
</template>

<script>
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    console.log(this.value[this.name]);
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
